import { useDispatch } from "react-redux";
import { loadingAction } from "../../store/actions/todoActions";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";

export const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  
  export const formatRupiah = (angka) => {
    if (!angka) return "Rp. 0";
    return `Rp. ${angka.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  };
  
  export const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  export const useHandleClickLoading = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (uri) => {
        dispatch(loadingAction(true));
        setTimeout(() => {
            dispatch(loadingAction(false));
            navigate(uri);
        }, 100);
    };
};

export const clearLocalStorageAndRedirect = () => {
  const handleClick = (uri) => {
    setTimeout(() => {
      window.location.replace(uri);
    }, 100);
  };
  localStorage.removeItem('isLogin');
  localStorage.removeItem('isProfile');
  handleClick('/');
};

export function useSessionTimer(sessionKey) {
  const [sessionData, setSessionData] = useState(() => {
    const storedData = sessionStorage.getItem(sessionKey);
    return storedData ? JSON.parse(storedData) : null;
  });

  const [sessionDuration, setSessionDuration] = useState(100000);

  useEffect(() => {
    if (sessionData !== null) {

      const timer = setTimeout(() => {
        endSession();
      }, sessionDuration);

      return () => clearTimeout(timer);
    }
  }, [sessionData, sessionDuration]);

  const startSession = (data) => {
    sessionStorage.setItem(sessionKey, JSON.stringify(data));
    setSessionData(data);
  };

  const endSession = () => {
    setSessionData(null);
    sessionStorage.removeItem(sessionKey);
    setSessionDuration(null);
  };

  return [sessionData, startSession];
}